/**
 * Deferred object.
 */
export type Deferred<T> = {
  /**
   * Resolves deferred promise with given value.
   * @param value
   */
  resolve(value: T): void;

  /**
   * Rejects deferred promise with given reason.
   * @param reason
   */
  reject(reason?: Error | any): void; // eslint-disable-line @typescript-eslint/no-explicit-any

  /**
   * Deferred promise.
   */
  promise: Promise<T>;
};

/**
 * Creates Deferred object.
 */
export function createDeferred<T>(): Deferred<T> {
  const deferred = {} as Deferred<T>;
  deferred.promise = new Promise<T>((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}
